export default "__VITE_ASSET__C2lJ0bvf__"